@if (!globalsService.token()) {
  <app-grid [gap]="24">
    <app-grid [gap]="12">
      @if (!verifyAgain) {
        <app-title [tag]="'h3'" [tag-class]="'h4'">{{ 'modals.save.title' | translate }}</app-title>
        <app-paragraph [font-size]="'small'">{{ 'modals.save.description' | translate }}</app-paragraph>
      } @else {
        <app-title [tag]="'h3'" [tag-class]="'h4'">{{ 'modals.save.againTitle' | translate }}</app-title>
        <app-paragraph [font-size]="'small'">{{ 'modals.save.againDescription' | translate }}</app-paragraph>
      }
    </app-grid>
    <app-form [formGroup]="form" (submited)="send()">
      <app-grid [gap]="8">
        <app-switch [name]="'type'" [size]="'small'" [title-left]="'forms.email' | translate" [title-right]="'forms.phone' | translate" [formControlName]="'type'"></app-switch>
        @if (!form.controls['type'].value) {
          <app-input
            [placeholder]="'forms.email' | translate"
            [name]="'email'"
            [autocomplete]="'on'"
            [required]="true"
            [formControlName]="'email'"
            [type]="'email'"
            [error]="form.controls['email'].invalid && form.controls['email'].touched"
            [error-message]="form.controls.email.hasError('email') ? ('forms.inputTypeError' | translate: { name: 'forms.email' | translate }) : ('forms.inputError' | translate)"
          ></app-input>
        } @else {
          <app-grid [template]="'102px auto'" [gap]="4">
            <app-phone-input [formControlName]="'phoneCode'"></app-phone-input>
            <app-input
              [placeholder]="'forms.phone' | translate"
              [name]="'phone'"
              [autocomplete]="'on'"
              [type]="'number'"
              [pattern]="'[0-9]*'"
              [formControlName]="'phone'"
              [required]="true"
              [error]="form.controls['phone'].invalid && form.controls['phone'].touched"
              [error-message]="form.controls.phone.hasError('phone') ? ('forms.inputTypeError' | translate: { name: 'forms.phone' | translate }) : ('forms.inputError' | translate)"
            ></app-input>
          </app-grid>
        }
      </app-grid>
      <app-button [type]="'submit'" [disabled]="form.invalid">{{ 'modals.save.button' | translate }}</app-button>
    </app-form>
  </app-grid>
} @else if (this.form.get('email')?.value || this.form.get('phone')?.value) {
  <app-grid [gap]="4">
    <app-color-text [color]="'primary'">
      <app-grid [display]="'flex'" [align]="'center'" [gap]="8">
        <app-icon [icon]="'check'" [width]="18" [height]="18"></app-icon>
        {{ 'modals.save.' + (!this.form.get('type')?.value ? 'confirmedEmail' : 'confirmedPhone') | translate }}
      </app-grid>
    </app-color-text>
    {{ !this.form.get('type')?.value ? this.form.get('email')?.value : (this.form.get('phone')?.value | hidePhone) }}
  </app-grid>
  @if (!verifyAgain) {
  } @else {
    <app-loader></app-loader>
  }
}
